import React from 'react'

import {
  HOMEPAGE_FIELDS,
  LOCAL_BUSINESS_FIELDS,
  SLIDE_FIELDS,
} from '../../constants/fieldGroups.constant'
import AbstractDocument from '../Abstract/AbstractDocument'

const Blog = function () {
  return (
    <AbstractDocument
      singleCollectionName="Blog"
      notToShow={[
        'ancestorIds',
        'parentId',
        'images',
        'videos',
        'type',
        ...SLIDE_FIELDS,
        ...HOMEPAGE_FIELDS,
        ...LOCAL_BUSINESS_FIELDS,
      ]}
    />
  )
}
export default Blog
